import { render, staticRenderFns } from "./ModalEditQualification.vue?vue&type=template&id=135b5fcd&"
import script from "./ModalEditQualification.vue?vue&type=script&lang=js&"
export * from "./ModalEditQualification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports